<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div class="text-h6">Edit Details</div>
      <div class="primaryGrey--text">XFMR ID : {{ asset_model.AssetID }}</div>
      <div class="primaryGrey--text">Serial Number : {{ asset_model.SerialNumber }}</div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row class="pt-6 pb-3">
          <v-col cols="6">
            <v-text-field color="primaryDark" dense label="XFMR ID" v-model="asset_model.AssetID"></v-text-field>
          </v-col>
          <v-col cols="6"> </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.CurrentLat"
              :rules="numberRule([-90, 90], false)"
              label="Latitude"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.CurrentLng"
              :rules="numberRule([-180, 180], false)"
              label="Longitude"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-expansion-panels tile flat v-model="show_panel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header class="primaryOutline--text pa-0 text-body-1 font-weight-bold"
              >DGA</v-expansion-panel-header
            >
            <v-expansion-panel-content class="mt-6">
              <v-row>
                <v-col cols="6">
                  <v-text-field color="primaryDark" dense label="Site" v-model="asset_model.SiteName"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    dense
                    color="primaryDark"
                    v-model="asset_model.OilType"
                    :items="page_content.h2_oiltype"
                    item-text="label"
                    item-value="value"
                    label="Liquid Type"
                    disabled
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    dense
                    color="primaryDark"
                    v-model="asset_model.OpMode"
                    :items="page_content.h2_opmode"
                    item-text="label"
                    item-value="value"
                    label="OP Mode"
                    disabled
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="primaryDark"
                    dense
                    label="H₂ PPM Alarm Limit"
                    v-model.number="asset_model.alarm"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="primaryDark"
                    dense
                    label="H₂ PPM Caution Limit"
                    v-model.number="asset_model.caution"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    dense
                    color="primaryDark"
                    label="Sensor Type"
                    v-model="asset_model.SensorType"
                    :items="page_content.H2SensorType"
                    item-text="label"
                    item-value="value"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    dense
                    color="primaryDark"
                    label="Sensor Location"
                    v-model="asset_model.SensorLocation"
                    :items="page_content.H2SensorLocation"
                    item-text="label"
                    item-value="value"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel v-if="$store.state.is_pq_enabeled">
            <v-expansion-panel-header class="primaryOutline--text pa-0 text-body-1 font-weight-bold"
              >Power Quality</v-expansion-panel-header
            >
            <v-expansion-panel-content class="mt-6">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    color="primaryDark"
                    dense
                    v-model="asset_model.TransformerName"
                    label="Transformer Name"
                    :counter="50"
                    :rules="maxRule(50, false)"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="primaryDark"
                    dense
                    v-model="asset_model.TransformerNo"
                    label="Transformer No."
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="primaryDark"
                    dense
                    v-model="asset_model.TransformerRating"
                    label="Transformer Rating (kVA)"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-select
                    dense
                    color="primaryDark"
                    v-model="asset_model.ConnectionType"
                    :items="page_content.ConnectionType"
                    label="Connection Type"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="primaryDark"
                    dense
                    v-model="asset_model.Comment"
                    label="Comments"
                    :rules="maxRule(500, false)"
                    :counter="500"
                    append-outer-icon="mdi-comment"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row no-gutters class="py-6">
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn dense outlined class="mr-2 bold" @click="$emit('cancel')">{{ $t("common.words.cancel") }}</v-btn>
            <v-btn dense color="primary" @click="validate('save', asset_model)" class="bold" :disabled="!valid">{{
              $t("common.words.save")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { content } from "../../config/config.js";

export default {
  name: "EditH2Details",
  props: { deviceId: String, asset_data: Object, default_panel: Array },
  data: function () {
    return {
      valid: true,
      show_panel: [0],
    };
  },
  watch: {
    default_panel: function (newVal) {
      this.show_panel = newVal;
    },
  },
  created() {
    this.page_content = content;
    if (this.default_panel) this.show_panel = this.default_panel;
  },
  computed: {
    formattedInstallationDate() {
      return this.$dateFormat(this.asset_model.InstallationDate);
    },
    asset_model: function () {
      return {
        TransformerName: (this.asset_data && this.asset_data.item.TransformerName) || null,
        TransformerNo: (this.asset_data && this.asset_data.item.TransformerNo) || null,
        TransformerRating: (this.asset_data && this.asset_data.item.TransformerRating) || null,
        Comment: (this.asset_data && this.asset_data.item.Comment) || null,
        ConnectionType: (this.asset_data && this.asset_data.item.ConnectionType) || null,

        AssetID: (this.asset_data && this.asset_data.item.AssetID) || "",
        CurrentLat: parseFloat(this.asset_data && this.asset_data.item.CurrentLat) || null,
        CurrentLng: parseFloat(this.asset_data && this.asset_data.item.CurrentLng) || null,
        DeviceID: (this.asset_data && this.asset_data.item.DeviceID) || null,

        SiteName: (this.asset_data && this.asset_data.item.SiteName) || null,
        SerialNumber: (this.asset_data && this.asset_data.item.SerialNumber) || "",
        DeviceStatus: (this.asset_data && this.asset_data.item.DeviceStatus) || null,
        H2Lvl: (this.asset_data && this.asset_data.item.H2Lvl) || null,
        LastMessageTime: (this.asset_data && this.asset_data.item.LastMessageTime) || null,
        OilTemp: (this.asset_data && this.asset_data.item.OilTemp) || null,
        OilType: (this.asset_data && this.asset_data.item.OilType) || null,
        OpMode: (this.asset_data && this.asset_data.item.OpMode) || null,
        alarm: parseFloat(this.asset_data && this.asset_data.item.alarm) || null,
        caution: parseFloat(this.asset_data && this.asset_data.item.caution) || null,
        SensorType: (this.asset_data && this.asset_data.item.SensorType) || null,
        SensorLocation: (this.asset_data && this.asset_data.item.SensorLocation) || null,
      };
    },
  },
  methods: {
    validate: function (event, obj) {
      //Validate the data and emit the event
      this.$emit(event, obj);
    },
    numberRule: function (digits, isRequired) {
      if (typeof digits == "number") {
        return isRequired
          ? [(v) => !!v || "This field is required", (v) => (v && v <= digits) || `Must be less than ${digits}`]
          : [(v) => !v || (v && v <= digits) || `Must be less than ${digits}`];
      } else {
        return isRequired
          ? [
              (v) => !!v || "This field is required",
              (v) =>
                (v && v <= digits[1] && v >= digits[0]) ||
                `Must be less than ${digits[1]} and greater than ${digits[0]}`,
            ]
          : [(v) => !v || (v && v <= digits[1] && v >= digits[0]) || `Must be less than ${digits}`];
      }
    },
    maxRule: function (characters, isRequired) {
      return isRequired
        ? [
            (v) => !!v || "This field is required",
            (v) => (v && v.length <= characters) || `Must be less than ${characters} characters`,
          ]
        : [(v) => !v || (v && v.length <= characters) || `Must be less than ${characters} characters`];
    },
  },
};
</script>

<style lang="scss" scoped>
.opaque {
  opacity: 0.7;
}

::v-deep.v-expansion-panel-header {
  min-height: 50px;
  border-bottom: 1px solid var(--v-backgroundLight-base) !important;
}
::v-deep.v-expansion-panel-content .v-expansion-panel-content__wrap {
  padding: 0px !important;
}
</style>
